import React from 'react';
function Icon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path fill="#1D252D" fillOpacity="0.7" d="M170.001-180.001q-29.154 0-49.577-20.423t-20.423-49.577v-442.305q0-29.153 21.577-50.73 21.577-21.577 50.731-21.577h243.077L480-699.999h307.691q26.846 0 46.307 17.346Q853.46-665.307 856.537-640H160v387.691q0 4.231 2.116 6.924 2.115 2.692 5.577 4.616L263.308-560h666.307l-99.154 330.307q-6.846 22.538-25.654 36.115-18.807 13.577-41.73 13.577H170.001z"></path>
    </svg>;
}
export default Icon;